import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Common.css';

function Webhooks({ apiBase }) {
  const [webhooks, setWebhooks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadWebhooks();
  }, []);

  const loadWebhooks = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${apiBase}/api/admin/webhooks?limit=50`);
      if (response.data.success) {
        setWebhooks(response.data.data);
      }
    } catch (error) {
      console.error('Error loading webhooks:', error);
    } finally {
      setLoading(false);
    }
  };

  const getBadgeClass = (status) => {
    if (status === 'processed') return 'badge badge-success';
    if (status === 'error') return 'badge badge-danger';
    return 'badge badge-warning';
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleString('en-KE', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  if (loading) {
    return <div className="loading">Loading webhooks...</div>;
  }

  return (
    <div className="component-container">
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Transaction ID</th>
              <th>Status</th>
              <th>Paid</th>
              <th>Result Code</th>
              <th>Receipt</th>
              <th>Received At</th>
            </tr>
          </thead>
          <tbody>
            {webhooks.length === 0 ? (
              <tr>
                <td colSpan="7" className="empty-state">No webhooks found</td>
              </tr>
            ) : (
              webhooks.map((webhook) => (
                <tr key={webhook.id}>
                  <td>#{webhook.id}</td>
                  <td>{webhook.local_id}</td>
                  <td>
                    <span className={getBadgeClass(webhook.status)}>
                      {webhook.status}
                    </span>
                  </td>
                  <td>
                    {webhook.payload.paid !== undefined ? (
                      <span className={webhook.payload.paid ? 'badge badge-success' : 'badge badge-warning'}>
                        {webhook.payload.paid ? 'Yes' : 'No'}
                      </span>
                    ) : '-'}
                  </td>
                  <td>{webhook.payload.result_code || '-'}</td>
                  <td>{webhook.payload.result?.ref_code || '-'}</td>
                  <td>{formatDate(webhook.created_at)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <button onClick={loadWebhooks} className="btn btn-primary" style={{marginTop: '1rem'}}>
        Refresh
      </button>
    </div>
  );
}

export default Webhooks;
